let pending;
export function loadYouTubeAPI() {
  if (window.YT?.Player) return Promise.resolve(window.YT);
  if (pending) return pending;
  pending = new Promise((resolve,reject)=>{
    const previous = window.onYouTubeIframeAPIReady;
    const script = document.createElement('script');
    let done = false;
    const finish = (error) => {
      if (done) return; done=true; clearTimeout(timer);
      if (window.onYouTubeIframeAPIReady === ready) window.onYouTubeIframeAPIReady=previous;
      if (error) { script.remove(); pending=null; reject(error); } else resolve(window.YT);
    };
    const ready = () => { try { previous?.(); } finally { finish(); } };
    window.onYouTubeIframeAPIReady=ready;
    const timer=setTimeout(()=>finish(new Error('Camera player connection timed out')),15000);
    script.src='https://www.youtube.com/iframe_api'; script.async=true;
    script.onerror=()=>finish(new Error('Camera player could not connect'));
    document.head.appendChild(script);
  });
  return pending;
}
export function cameraError(code) {
  if (code === 100) return 'This video was removed, is private or is unavailable.';
  if (code === 101 || code === 150) return 'The provider rejected embedded playback. Open its video page or try another feed.';
  if (code === 153) return 'The provider could not verify this embedded player.';
  return 'This camera could not be played here.';
}
